<label class="radio-menu-element">
  <input
    type="radio"
    [id]="column() + '-' + data().value"
    [name]="column()"
    [checked]="data().isActive === true"
    (click)="setRadioValue()"
  />

  @if (column() === 'level') {
    <span class="dot" [class]="data().value"></span>
  } @else if (column() === 'country' && iconUrl(); as iconUrl) {
    <img class="country-flag" [src]="iconUrl" [alt]="data().label" />
  } @else if (data().icon; as icon) {
    @if (column() !== 'status') {
      <kin-icon [color]="colorService.neutral500()" [name]="icon" />
    }
  }

  @if (column() === 'disponibility' && data().value !== 'waiting') {
    @let isWebsiteOnly = data().value === 'website-only';
    <app-chip
      text="table.disponibility.website"
      icon="language"
      [backgroundColor]="colorService.neutral100()"
      [color]="colorService.neutral600()"
    />
    <app-chip
      text="table.disponibility.app"
      icon="computer"
      [backgroundColor]="isWebsiteOnly ? colorService.backgroundColor() : colorService.neutral100()"
      [color]="colorService.neutral600()"
      [isCrossedOut]="isWebsiteOnly"
    />
  } @else if (column() === 'status') {
    <app-chip
      [text]="data().label"
      [icon]="data().icon!"
      [borderColor]="colorService.neutral900()"
      [backgroundColor]="
        data().value === 'private' ? colorService.neutral900() : colorService.backgroundColor()
      "
      [color]="data().value === 'private' ? colorService.neutral100() : colorService.neutral900()"
    />
  } @else {
    <span>{{ data().label | translate }}</span>
  }
</label>
